module.exports = __webpack_public_path__ + "img/about-img.212056cc.png";